// extracted by mini-css-extract-plugin
export var brand = "_8y-9";
export var compact = "_8y-6";
export var extraSmall = "_8y-7";
export var icon = "_8y-0";
export var large = "_8y-4";
export var light = "_8y-1";
export var medium = "_8y-5";
export var outline = "_8y-b";
export var primaryDark = "_8y-a";
export var primaryLight = "_8y-8";
export var primaryModern = "_8y-c";
export var success = "_8y-2";
export var successSolid = "_8y-3";